import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ImageClickable } from './ImageClickable';
export function Bonuses() {
  const bonuses = [{
    title: 'Cómo no volver a lo mismo',
    img: 'https://cdn.magicpatterns.com/uploads/1d9CSh5N7ZPG5dpE4sLC4b/Bono_1.png'
  }, {
    title: 'Código de la mujer que se elige',
    img: 'https://cdn.magicpatterns.com/uploads/6JjUzNfq8JahwKrxJyt7LK/Bono_2.png'
  }, {
    title: 'Estándares nuevos',
    img: 'https://cdn.magicpatterns.com/uploads/k1JWACbtKKUnG6yrCsPUPh/Bono_3.png'
  }, {
    title: 'Cómo detectar manipulación emocional',
    img: 'https://cdn.magicpatterns.com/uploads/fyESU5MddPD9YFzfES2MLL/Bono_4.png'
  }, {
    title: 'Camino del desarrollo personal',
    img: 'https://cdn.magicpatterns.com/uploads/4GLbb2vGefW2Cw1twBKVJt/Bono_5.png'
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const handleScroll = useCallback(() => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const scrollLeft = container.scrollLeft;
    const itemWidth = container.scrollWidth / bonuses.length;
    const newIndex = Math.round(scrollLeft / itemWidth);
    setActiveIndex(Math.min(newIndex, bonuses.length - 1));
  }, [bonuses.length]);
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    container.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
  return <section className="py-8 md:py-10 px-3 md:px-4 bg-black" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        <div className="text-center mb-8" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase mb-2" data-id="element-35">
            Bonos incluidos
          </h2>
          <div className="inline-block bg-rosa text-white font-black px-4 py-1 rounded-full text-sm uppercase tracking-widest animate-pulse" data-id="element-36">
            Gratis por el día de hoy
          </div>
        </div>

        {/* Mobile carousel */}
        <div className="md:hidden" data-id="element-37">
          <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-4 hide-scrollbar" data-id="element-38">
            {bonuses.map((bonus, idx) => <div key={idx} className="bg-dark rounded-xl overflow-hidden border border-white/10 flex flex-col flex-shrink-0 w-[80vw] max-w-[320px] snap-center" data-id="element-39">
                <div className="aspect-[3/4] w-full relative" data-id="element-40">
                  <ImageClickable src={bonus.img} alt={bonus.title} className="w-full h-full object-cover rounded-none" data-id="element-41" />
                  <div className="absolute top-2 right-2 bg-terracota text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-42">
                    Bono {idx + 1}
                  </div>
                </div>
                <div className="p-3 flex-grow flex items-center justify-center text-center" data-id="element-43">
                  <h4 className="text-white font-semibold text-sm leading-tight" data-id="element-44">
                    {bonus.title}
                  </h4>
                </div>
              </div>)}
          </div>
          {/* Instagram-style dot indicators */}
          <div className="flex justify-center gap-1.5 mt-3" data-id="element-45">
            {bonuses.map((_, idx) => <div key={idx} className={`rounded-full transition-all duration-300 ${idx === activeIndex ? 'w-2.5 h-2.5 bg-rosa' : 'w-2 h-2 bg-white/30'}`} data-id="element-46" />)}
          </div>
        </div>

        {/* Desktop grid */}
        <div className="hidden md:grid grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-47">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-dark rounded-xl overflow-hidden border border-white/10 flex flex-col group hover:border-rosa/50 transition-colors" data-id="element-48">
              <div className="aspect-[3/4] w-full relative" data-id="element-49">
                <ImageClickable src={bonus.img} alt={bonus.title} className="w-full h-full object-cover rounded-none" data-id="element-50" />
                <div className="absolute top-2 right-2 bg-terracota text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-51">
                  Bono {idx + 1}
                </div>
              </div>
              <div className="p-3 flex-grow flex items-center justify-center text-center" data-id="element-52">
                <h4 className="text-white font-semibold text-sm leading-tight" data-id="element-53">
                  {bonus.title}
                </h4>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}